import React, { useState } from 'react';
import { color, Common } from '@stockbit/ui';
import { useDispatch, useSelector } from 'react-redux';
import {
  effects as userEffects,
  selectors as userSelectors,
} from 'lib/entities/user';
import { AVATAR_URL } from 'constants/api';
import { effects as watchlistEffects } from 'lib/entities/watchlist';
import { handleErrorAvatar } from 'utils/general';
import Image from 'global/Image';
import auth from 'utils/auth';
import If from 'global/ErrorHandlers/If';
import Username from './Username';
import UserStat from './UserStat';

import ButtonMore from './ButtonMore';
import { TextAbout } from '../styled';
import { UserGraph } from '../../../../../@types/user';

const { Button, Popover, PopoverContentWrapper, Flex, Text, Avatar } = Common;

interface PopoverUserProps {
  children: React.ReactNode;
  username: string;
  [key: string]: any;
}

function PopoverUser({ children, username, ...otherProps }: PopoverUserProps) {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);
  const { detail: userDetail } = useSelector(userSelectors);

  const currentUser: UserGraph = userDetail[username] ? userDetail[username] : {};
  const userAvatar = currentUser?.profile?.avatar_urls?.default_url;
  const avatarUrl = userAvatar?.startsWith('http')
    ? userAvatar
    : `${AVATAR_URL}/${currentUser?.profile?.avatar_urls?.default_url}`;

  const handleEnter = async () => {
    // @ts-ignore
    if (!userDetail[username]) {
      // @ts-ignore
      const request = await dispatch(userEffects.getUserProfile(username));

      // @ts-ignore
      if (request?.payload?.data) {
        setVisible(true);
      }
    } else {
      setVisible(true);
    }
  };

  /**
   * @param {Event} e
   */
  const handleFollowUser = (e) => {
    e.stopPropagation();

    const type = currentUser?.status?.is_followed ? 'UNFOLLOW' : 'FOLLOW';
    const data = {
      username,
      userid: currentUser?.user_id,
      type,
    };

    dispatch(watchlistEffects.followUser(data));
  };

  const userStatData = [
    {
      value: currentUser?.statistic?.idea_count || 0,
      icon: 'icon-profile_post',
      label: 'Post',
    },
    {
      value: currentUser?.statistic?.follower_count || 0,
      icon: 'icon-profile_people',
      label: 'Followers',
    },
    {
      value: currentUser?.statistic?.following_count || 0,
      icon: 'icon-profile_people',
      label: 'Following',
    },
  ];

  // @ts-ignore
  const showFollowButton = username !== auth.getUserAccess()?.username;

  return (
    <Popover
      {...otherProps}
      trigger="hover"
      placement="rightTop"
      overlayStyle={{
        minWidth: '300px',
      }}
      mouseEnterDelay={0.7}
      onMouseEnter={handleEnter}
      onVisibleChange={(show) => {
        setVisible(show);
      }}
      content={() => (
        <PopoverContentWrapper padding="15px">
          <Flex justify="space-between">
            <div style={{ maxWidth: '200px' }}>
              <Username user={currentUser} />
              <TextAbout padding="10px 10px 10px 0">
                {currentUser?.profile?.about}
              </TextAbout>
              {/* {currentUser?.profile?.gender !== '' && (
                <Text padding="10px 10px 10px 0">
                  {currentUser?.profile?.gender?.toLowerCase()}
                </Text>
              )} */}
            </div>
            <Avatar size="large" padding="0">
              <Image
                alt=""
                src={avatarUrl}
                onError={(e) => handleErrorAvatar(e, username)}
              />
            </Avatar>
          </Flex>
          <Flex justify="space-between" margin="16px 0" width="85%">
            {userStatData.map(({ value, icon, label }) => (
              <UserStat key={label} value={value} icon={icon} label={label} />
            ))}
          </Flex>
          <If condition={showFollowButton}>
            <Flex>
              <Button height="30px" onClick={handleFollowUser}>
                <Text color={color.primary}>
                  {currentUser?.status?.is_followed ? 'Following' : 'Follow'}
                </Text>
              </Button>
              {visible && (<ButtonMore username={username} user={currentUser} />)}
            </Flex>
          </If>
        </PopoverContentWrapper>
      )}
    >
      {children}
    </Popover>
  );
}

export default PopoverUser;
